<template>
  <div class="edit-box">
    <GoBackView />
    <MineHeaderView @click-icon="openMenu" />
    <MineMenuView ref="mmv" />
    <div class="result-state" v-if="usrData">
      <img src="../../assets/img/card/pass.png" style="width: 120px;height: 120px;" v-if="usrData.rzstatus == 2" />
    </div>
    <div class="frm-area" v-if="usrData">
      <div class="title">身份认证</div>
      <div class="frm-box">
        <van-form @submit="onSubmit">
          <div class="frm-item">
            <div class="frm-label">真实姓名</div>
            <van-field
              v-model="frm.real_name"
              placeholder="请填写您的真实姓名"
              :rules="[{ required: true, message: '请填写您的真实姓名' }]"
              :readonly="!(usrData.rzstatus == 0 || usrData.rzstatus == 3)"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">证件号码</div>
            <van-field
              v-model="frm.card_number"
              placeholder="请填写您的证件号码"
              :rules="[{ required: true, message: '请填写您的证件号码' }]"
              :readonly="!(usrData.rzstatus == 0 || usrData.rzstatus == 3)"
            />
          </div>
          <div class="frm-item" style="display: none;">
            <div class="frm-label">身份证件正面</div>
            <div style="padding: 16px 16px">
              <van-uploader
                v-model="fileList1"
                multiple
                :after-read="afterRead1"
                :max-count="1"
                :before-read="beforeRead"
                :before-delete="file1Delete1"
                :deletable="(usrData.rzstatus == 0 || usrData.rzstatus == 3)"
              >
                <img
                  src="../../assets/img/card/idcard1.png"
                  style="height: 124px"
                />
              </van-uploader>
              <div v-if="isUploadfront" style="color: #ee0a24; font-size: 12px">
                请上传身份证件正面
              </div>
            </div>
          </div>
          <div class="frm-item"  style="display: none;">
            <div class="frm-label">身份证件反面</div>
            <div style="padding: 10px 16px">
              <van-uploader
                v-model="fileList2"
                multiple
                :after-read="afterRead2"
                :max-count="1"
                :before-read="beforeRead"
                :before-delete="file1Delete2"
                :deletable="(usrData.rzstatus == 0 || usrData.rzstatus == 3)"
              >
                <img
                  src="../../assets/img/card/idcard2.png"
                  style="height: 124px"
                />
              </van-uploader>
              <div v-if="isUploadback" style="color: #ee0a24; font-size: 12px">
                请上传身份证件反面
              </div>
            </div>
          </div>
          <div class="btn-box">
            <van-button
              native-type="submit"
              :loading="posting"
              loading-text="提交中..."
              style="background-color: #141423; color: #fff; border-radius: 8px"
              v-if="usrData.rzstatus == 0 || usrData.rzstatus == 3"
              >提交认证</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import { getToken } from '@/utils/cookies'
import { MineHeaderView, MineMenuView } from './components/index'
import GoBackView from '@/components/goback/index.vue'
export default {
  name: 'CertificationView',
  components: { MineHeaderView, MineMenuView,GoBackView },
  data () {
    return {
      posting: false,
      updateIcon: require('@/assets/img/card/idcard1.png'),
      fileList1: [],
      fileList2: [],
      frm: {
        real_name: null,
        card_number: null,
        front_card: null,
        back_card: null
      },
      isUploadfront: false,
      isUploadback: false,
      usrData: null
    }
  },
  mounted () {
    this.getUsr()
  },
  methods: {
    async getUsr () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        this.usrData = res.data
        this.frm.real_name = this.usrData.uname
        this.frm.card_number = this.usrData.card_number
        this.frm.front_card = this.usrData.cardzm
        this.frm.back_card = this.usrData.cardfm

        if (this.usrData.cardzm && this.usrData.cardzm.length > 0) {
          this.fileList1.push({ url: this.usrData.cardzm })
        }

        if (this.usrData.cardfm && this.usrData.cardfm.length > 0) {
          this.fileList2.push({ url: this.usrData.cardfm })
        }
      })
    },
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    beforeRead (file) {
      this.isUploadfront = false
      this.isUploadback = false
      const validTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml',
        'image/apng',
        'image/avif'
      ]
      if (!validTypes.includes(file.type)) {
        this.$toast.fail('请上传图片文件')
        return false
      }
      return true
    },
    async afterRead1 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            file.status = ''
            this.frm.front_card = response.data.data.url
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete1 () {
      this.frm.front_card = null
      this.fileList1 = []
    },
    async afterRead2 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            file.status = ''
            this.frm.back_card = response.data.data.url
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete2 () {
      this.frm.back_card = null
      this.fileList2 = []
    },
    async onSubmit () {
      /*
      if (!(this.frm.front_card && this.frm.front_card.length)) {
        this.isUploadfront = true
        return false
      }
      if (!(this.frm.back_card && this.frm.back_card.length)) {
        this.isUploadback = true
        return false
      }
        */

      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'usersetReal',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          this.$toast.success(res.msg)
          location.reload()
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  margin: 40px 10px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  position: relative;
  .result-state {
    position: absolute;
    top: 60px;
    right: 20px;
    z-index: 99;
  }
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">
.frm-box {
  .van-uploader__preview-image {
    width: 200px !important;
    height: 124px !important;
  }
}
</style>
